import { FC } from "react";
import { useReopenedStages } from "../../../hooks/useReopenedStages";
import { hasReopenedStages } from "../../../utils/stageHelper";
import MyProfile from "../MyProfile";
import MyProfileReopened from "../MyProfileReopened";

/**
 * Wrapper component that conditionally renders MyProfile or MyProfileReopened
 * based on whether the candidate has any reopened stages
 */
const MyProfileWrapper: FC = () => {
  // Use custom hook to get candidate data for helper functions
  const { candidateForHelper } = useReopenedStages();

  // Check if any stages are reopened
  const hasReopened = hasReopenedStages(candidateForHelper);

  // Render the appropriate component based on reopened status
  return hasReopened ? <MyProfileReopened /> : <MyProfile />;
};

export default MyProfileWrapper;
